import { TRIGGER_LOGOUT_REQUEST } from "@reducers";

// Action creators
const TriggerLogoutRequest = (path: string) => ({
  type: TRIGGER_LOGOUT_REQUEST,
  payload: {
    address: path,
  },
});

export default TriggerLogoutRequest;
